
import { defineComponent, ref, getCurrentInstance, onActivated } from 'vue';
import Search from 'vant/lib/search';
import Toast from 'vant/lib/toast';
import { copyToClipboard } from '@/common/utils';
import { sendLog } from '@/common/radar';

export default defineComponent({
    components: {
        Search,
    },
    props: {
        pageSource: {
            type: String,
            required: true,
            default: '',
        },
        isSearchWordFromParams: {
            type: Boolean,
            default: false,
        },
        isShareEnabled: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: Record<string, any> };
        const searchText = ref('');
        const hasFoucs = ref(false);

        const handleBackClick = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'back',
                },
            });
            window.history.back();
        };

        const handleShare = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'share',
                },
            });

            const copyUrl = window.location.href;
            copyToClipboard(copyUrl);
            Toast({
                message: proxy.$root.$t('k_446636'),
            });
        };

        const handleSearch = () => {
            sendLog({
                type: 'click',
                name: 'MOBILE_TOP_CLICK_AREA',
                value: {
                    button_type: 'research',
                },
            });
            proxy.$router.push({ path: `/discover/${searchText.value}`, query: { page_source: props.pageSource } });
        };

        const handleFocus = () => {
            hasFoucs.value = true;
        };

        const handleKeyDown = () => {};

        onActivated(() => {
            if (props.isSearchWordFromParams) {
                searchText.value = proxy.$route.params.content?.replace(/(-)/g, ' ');
            }
        });

        return {
            searchText,
            hasFoucs,
            handleBackClick,
            handleShare,
            handleFocus,
            handleSearch,
            handleKeyDown,
        };
    },
});
